import { render, staticRenderFns } from "./PainelProjetosSecli.vue?vue&type=template&id=7ca50646"
import script from "./PainelProjetosSecli.vue?vue&type=script&lang=js"
export * from "./PainelProjetosSecli.vue?vue&type=script&lang=js"
import style0 from "./PainelProjetosSecli.vue?vue&type=style&index=0&id=7ca50646&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports